
import CidadeBreadcrumb from "@/components/CidadeBreadcrumb";

interface CidadeHeroProps {
  cidadeFormatted: string;
  estadoNome: string;
  estado: string;
}

const CidadeHero = ({ cidadeFormatted, estadoNome, estado }: CidadeHeroProps) => {
  return (
    <div className="py-16 px-6 md:px-12 bg-gradient-to-br from-white to-seo-light">
      <div className="max-w-4xl mx-auto">
        <CidadeBreadcrumb estado={estado} estadoNome={estadoNome} cidade={cidadeFormatted} />

        <h1 className="text-3xl md:text-5xl font-bold mb-6 text-seo-dark">
          SEO Local para Empresas em {cidadeFormatted}
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 text-gray-700">
          Atraia mais clientes em {cidadeFormatted} com estratégias de SEO Local personalizadas para sua empresa.
        </p>
      </div>
    </div>
  );
};

export default CidadeHero;
